import React from "react";
import { urlAvatar } from "../../../utils/Constant";
import { useTranslation } from "react-i18next";
import { validateImg, validate } from "../../../utils/Validation";
import { connect } from "react-redux";
import { changeInfo } from "../../../store/actions";
import { CardPink } from "../../../components/card";
import "./style/Perfil.css";
import { ChangeImage } from "../../../containers/account";
import { processUrlImage } from "../../../utils/ProcessData";
function Perfil(props) {
  const { sesionUser, changeInfo } = props;
  const { t } = useTranslation("account");
  function ChangeImg() {
    changeInfo(<ChangeImage />);
  }
  const url = processUrlImage(
    sesionUser ? validateImg(sesionUser.user.photoUrl) : urlAvatar,
    120
  );
  return (
    <div className="Perfil">
      <div className="Perfil__photo">
        <div
          style={{
            backgroundImage: `url(${url})`,
          }}
          className="Perfil__Pimg"
        >
          <div className="Perfil__photoBtn">
            <i className="fas fa-plus" onClick={ChangeImg}></i>
          </div>
        </div>
      </div>
      <div className="Perfil__information">
        <CardPink
          title={t("acUser")}
          data={sesionUser ? validate(sesionUser.user.username) : "--"}
        />
        <CardPink
          title={t("nickname")}
          data={sesionUser ? validate(sesionUser.user.nickname) : "--"}
        />
        <CardPink
          title={t("acName")}
          data={
            sesionUser
              ? validate(sesionUser.user.firstName) +
                " " +
                validate(sesionUser.user.lastName)
              : ""
          }
        />
        <CardPink
          title={t("acEmail")}
          data={sesionUser ? validate(sesionUser.user.email) : "--"}
        />
        <CardPink
          title={t("acPhone")}
          data={sesionUser ? validate(sesionUser.user.telephone) : "--"}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    sesionUser: state.sesionUser,
  };
};
const mapDispatchToProps = {
  changeInfo,
};
export default connect(mapStateToProps, mapDispatchToProps)(Perfil);
